/**
 * @file Defines the filters constant
 * @author Joe Thompson <joe.thompson @1x2network.com>
 */

 /**
  * Object of regular expression filters
  * @type {object}
  * @constant
  * @default
  */
 const FILTERS = {

    currency: /^\d*[.]?\d{0,2}$/

 }

 export { FILTERS }